module.exports = __webpack_public_path__ + "static/media/Rolling.36257ef1.gif";